document.addEventListener('DOMContentLoaded', () => {
  function updateIcons() {
    const ls = Wishlist.get().map((p) => p.handle);
    document.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      const handle = btn.dataset.wishlistHandle;
      if (ls.includes(handle)) {
        btn.classList.add('wishlisted');
      } else {
        btn.classList.remove('wishlisted');
      }
    });
  }

  // Click listener
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;

    const productData = JSON.parse(btn.dataset.productJson);
    const added = Wishlist.toggle(productData);

    btn.classList.toggle('wishlisted', added);
  });

  updateIcons();

  document.addEventListener('wishlist:updated', updateIcons);
});
